<template>
  <v-container fluid class="ai-page">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="8" md="5" lg="4">
        <v-select
          outlined
          dense
          hide-details
          background-color="white"
          prepend-inner-icon="mdi-domain"
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Empresa"
          @input="carregaChamadores(empresaSelecionada)"
        ></v-select>
      </v-col>
    </v-row>

    <v-card class="ai-panel" :class="{ 'mt-3': user.tipo == 'ADMIN' }" elevation="0">
      <div class="ai-panel__head">
        <div class="ai-panel__title">
          <v-icon>mdi-room-service</v-icon>
          Chamadores
          <span class="ai-count">{{ tabela.conteudo.length }}</span>
        </div>
        <div class="ai-panel__spacer"></div>
        <v-text-field
          v-model="tabela.busca"
          append-icon="mdi-magnify"
          label="Procurar"
          single-line
          hide-details
          dense
          outlined
          class="ai-search"
        ></v-text-field>
        <v-btn color="primary" depressed @click="dialogoChamador = true" :disabled="user.tipo == 'ADMIN' ? empresaSelecionada == '' : false">
          <v-icon left>mdi-plus</v-icon>Cadastrar
        </v-btn>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-by="numero"
        class="ai-datatable"
        :footer-props="{ 'items-per-page-text': 'Linhas por página', 'items-per-page-all-text': 'Tudo' }"
        :loading="tabela.carregamento"
        loading-text="Buscando itens..."
      >
        <template v-slot:[`item.tipo`]="{ item }">
          <v-chip x-small label outlined color="secondary">
            <v-icon x-small left>{{ iconeTipo(item.tipo) }}</v-icon>{{ rotuloTipo(item.tipo) }}
          </v-chip>
        </template>
        <template v-slot:[`item.estado`]="{ item }">
          <span class="ai-status" :class="!item.estado ? 'success--text' : 'error--text'">
            <v-icon x-small :color="!item.estado ? 'success' : 'error'">mdi-circle</v-icon>
            {{ !item.estado ? 'Normal' : 'Chamando' }}
          </span>
        </template>
        <template v-slot:[`item.bateria`]="{ item }">
          <span v-if="item.bateria != null">
            <v-icon x-small :color="item.bateria < 20 ? 'error' : 'success'">{{ iconeBateria(item.bateria) }}</v-icon>
            {{ item.bateria }}%
          </span>
          <span v-else class="text--disabled">—</span>
        </template>
        <template v-slot:[`item.sinal`]="{ item }">
          <span v-if="item.sinal != null">{{ item.sinal }}</span>
          <span v-else class="text--disabled">—</span>
        </template>
        <template v-slot:[`item.keepAlive`]="{ item }">
          <span v-if="item.keepAlive">{{ transformaData(item.keepAlive.replace('.000Z', '-03:00'), 'DD/MM/YYYY') }} às {{ transformaData(item.keepAlive.replace('.000Z', '-03:00'), 'HH:mm:ss') }}</span>
          <span v-else class="text--disabled">—</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="editItem(item)"><v-icon color="info">mdi-pencil</v-icon></v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="excluirChamador(item)"><v-icon color="error">mdi-delete</v-icon></v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <div class="py-6">
            <v-alert v-if="user.tipo == 'ADMIN' && empresaSelecionada == ''" dense text outlined color="info" class="ma-0 d-inline-flex">
              <v-icon left color="info">mdi-information</v-icon>Selecione uma empresa para visualizar os chamadores
            </v-alert>
            <v-alert v-else dense text outlined color="warning" class="ma-0 d-inline-flex">
              <v-icon left color="warning">mdi-bell-off</v-icon>Nenhum chamador cadastrado
            </v-alert>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogoChamador" persistent max-width="700px" scrollable class="ai-dialog">
      <v-card>
        <v-card-title><v-icon>mdi-room-service</v-icon>{{ formTitle }}</v-card-title>
        <v-card-text class="ai-dialog-body">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field label="Nome*" outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select label="Tipo*" outlined dense hide-details v-model="editedItem.tipo" :items="tipos"></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Ordem*" outlined dense hide-details v-model="editedItem.ordem" type="tel"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Descrição*" outlined dense hide-details v-model="editedItem.descricao"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field label="Número*" outlined dense hide-details v-model="editedItem.numero"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-switch v-model="editedItem.estado" inset label="Estado (chamando)" hide-details class="mt-1"></v-switch>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Tag RF*" outlined dense hide-details v-model="editedItem.tagRF"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogoChamador = false">Fechar</v-btn>
          <v-btn depressed color="primary" @click="salvarChamador" v-if="editedIndex == -1">Salvar</v-btn>
          <v-btn depressed color="primary" @click="editarChamador" v-if="editedIndex != -1">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#038b8b" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      empresas: [],
      empresaSelecionada: '',
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'Descrição', value: 'descricao' },
          { text: 'Número', value: 'numero' },
          { text: 'Tag RF', value: 'tagRF' },
          { text: 'Tipo', value: 'tipo' },
          { text: 'Estado', value: 'estado' },
          { text: 'Bateria', value: 'bateria' },
          { text: 'Sinal', value: 'sinal' },
          { text: 'Última interação', value: 'keepAlive' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        carregamento: false,
        conteudo: [],
      },
      dialogoChamador: false,
      editedIndex: -1,
      editedItem: {
        descricao: '',
        numero: '',
        peso: 0,
        estado: false,
        observacoes: '',
        empresaId: '',
        tagRF: '',
        nome: '',
        visivel: false,
        tipo: '',
        ordem: 1,
      },
      defaultItem: {
        descricao: '',
        numero: '',
        peso: 0,
        estado: false,
        observacoes: '',
        empresaId: '',
        tagRF: '',
        nome: '',
        visivel: false,
        tipo: '',
        ordem: 1,
      },
      tipos: [
        { text: "Banheiro", value: "BANHEIRO" },
        { text: "Chamador", value: "CHAMADOR"} ,
        { text: "Soro", value: "SORO" },
      ],
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo chamador' : 'Editar chamador'
      },
    }),

    watch: {
      dialogoChamador(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedIndex = -1
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },

      empresas() {
        this.empresaSelecionada = this.empresas[0].id
        this.carregaChamadores(this.empresaSelecionada)
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaChamadores(this.companyobj.id)
      }
    },

    methods: {
      rotuloTipo(tipo) {
        const map = { BANHEIRO: 'Banheiro', CHAMADOR: 'Chamador', SORO: 'Soro' }
        return map[tipo] || tipo
      },
      iconeTipo(tipo) {
        const map = { BANHEIRO: 'mdi-toilet', CHAMADOR: 'mdi-bell-ring', SORO: 'mdi-iv-bag' }
        return map[tipo] || 'mdi-bell'
      },
      iconeBateria(nivel) {
        if (nivel >= 90) return 'mdi-battery'
        if (nivel >= 60) return 'mdi-battery-70'
        if (nivel >= 30) return 'mdi-battery-40'
        if (nivel >= 10) return 'mdi-battery-20'
        return 'mdi-battery-alert'
      },

      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      async carregaChamadores(id) {
        this.tabela.conteudo = []
        this.isLoading = true
        this.tabela.carregamento = true
        await axios.get(baseApiUrl + 'Chamadores?filter={"where":{"empresaId":"' + id + '"}, "order": "numero ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
          this.isLoading = false
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoChamador = true
        this.isLoading = false
      },

      async salvarChamador() {
        var vm = this;
        if (!this.editedItem.nome || !this.editedItem.descricao || !this.editedItem.numero || !this.editedItem.tipo) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha todos os campos para prosseguir", "ATENÇÃO")
        } else {
          this.isLoading = true
          this.editedItem.empresaId = this.empresaSelecionada
          this.editedItem.ordem = parseInt(this.editedItem.ordem)
          await axios.post(baseApiUrl + 'Chamadores?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.dialogoChamador = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaChamadores(this.empresaSelecionada)
              this.isLoading = false
            }
          })
          .catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("red", "Problema ao realizar operação, tente novamente", "DESCULPE")
          })
        }
      },

      async editarChamador() {
        var vm = this;
        if (!this.editedItem.nome || !this.editedItem.descricao || !this.editedItem.numero || !this.editedItem.tipo) {
          vm.$refs.chamaSnackbar.snack("orange", "Preencha os campos para prosseguir", "ATENÇÃO")
        } else {
          this.isLoading = true
          this.editedItem.ordem = parseInt(this.editedItem.ordem)
          await axios.put(baseApiUrl + 'Chamadores/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoChamador = false
              vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
              this.carregaChamadores(this.empresaSelecionada)
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "#BF4554")
          })
        }
      },

      async excluirChamador(item) {
        var r = confirm('Realmente deseja EXCLUIR o chamador ' + item.nome + ' (' + item.descricao + ' ' + item.numero + ')?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Chamadores/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaChamadores(this.empresaSelecionada)
          })
        }
      },

      transformaData(data, formato) {
        let date = moment(data).format(formato);
        return date
      },
    },
  }
</script>

<style scoped>
</style>
